/**
 * LinkIndicator — compact "this row has linked record(s)" badge for tables.
 */

import { Link2 } from "lucide-react";

export function LinkIndicator({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span
      className="inline-flex items-center gap-0.5 rounded-md bg-violet-100 px-1 py-0.5 text-violet-600 dark:bg-violet-950/40 dark:text-violet-300"
      title={`${count} linked record${count > 1 ? "s" : ""}`}
    >
      <Link2 className="h-3.5 w-3.5" />
      <span className="text-[10px] font-semibold tabular-nums">{count}</span>
    </span>
  );
}
